import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { AmountOptions } from 'enums/onboarding/crm';
import { FormSelectProps, SelectOption } from '@ui';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const ProjectedRevenueSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(AmountOptions).map((key) => ({
        id: key,
        label: t(`intake_form.amount_options.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default ProjectedRevenueSelect;
